import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';
import { ListingPhoto } from './types/Listing';

export default (makeCall: MakeCall) => (listingId: number, photoId: number) =>
  makeCall<ListingPhoto[]>(
    'PUT',
    `${APIV2_URL}/listing/${listingId}/photo/${photoId}/confirm`,
  );
